import Shimmer from "@components/core/Shimmer/Shimmer";
import ShimmerWrapper from "@components/core/Shimmer/ShimmerWrapper";

export const AutomationActionEditorSkeleton = () => {
    return (
        <ShimmerWrapper direction='column' spacing={24} align='center'>
            <Shimmer width='100%' height={32} radius={6} />
            <Shimmer width='100%' height={32} radius={6} />
            <Shimmer width='100%' height={300} radius={6} />
        </ShimmerWrapper>
    );
};

export const AutomationSkeleton = () => {
    return (
        <ShimmerWrapper spacing={32}>
            <ShimmerWrapper direction='column' spacing={24} align='center'>
                <ShimmerWrapper direction='row' spacing={32} align='center'>
                    <Shimmer width='140px' height={32} radius={6} />
                    <Shimmer width='140px' height={32} radius={6} />
                </ShimmerWrapper>
                <AutomationActionEditorSkeleton />
            </ShimmerWrapper>

        </ShimmerWrapper>
    );
};


export default AutomationSkeleton;
